import React from 'react';
import { Card, Checkbox } from 'antd';

export default class Contract extends React.Component {
	state = {
		disabled: true
	}
	enableCheckbox = () => this.setState({ disabled: false });
	render() {
		const { getFieldDecorator, title, link, extraText, agreeText, field, initialValue } = this.props;
		const valueForChecked = this.props.valueForChecked || 'R';
		return (
			<Card>
				<h3>
					<a href={link} onClick={this.enableCheckbox} target="_blank">
						{title} <span style={{color:'red'}}>*</span>
					</a>
				</h3>
				<div>
					{extraText && <div>{extraText}</div>}
					{getFieldDecorator(field, {
						valuePropName: 'checked',
						initialValue: initialValue === valueForChecked
					})(
						<Checkbox disabled={this.state.disabled || initialValue === valueForChecked || this.props.disabled}>
							{agreeText}
						</Checkbox>
					)}
				</div>
			</Card>
		);
	}
}


// WEBPACK FOOTER //
// ./portal-components/Contract/index.jsx